import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const items = [
  { q: "Términos y condiciones", a: "El uso de esta herramienta implica la aceptación de estos términos. El usuario es responsable del contenido que genera y de su uso posterior." },
  { q: "Uso de Inteligencia Artificial", a: "Las imágenes generadas mediante IA pueden no ser exactas o consistentes. Se recomienda revisar los resultados antes de su uso comercial." },
  { q: "Sistema de créditos", a: "El uso funciona mediante créditos. Cada generación consume créditos según el modelo seleccionado. Los créditos no son reembolsables una vez utilizados." },
  { q: "Pagos", a: "Los pagos se gestionan mediante Stripe. No almacenamos información de pago." },
  { q: "Privacidad", a: "No compartimos datos personales con terceros. Las imágenes subidas se utilizan únicamente para generar tu resultado." },
  { q: "Cookies y almacenamiento", a: "Podemos utilizar almacenamiento local del navegador para mejorar la experiencia del usuario." },
  { q: "Limitación de responsabilidad", a: "No nos hacemos responsables de daños derivados del uso del servicio o del contenido generado." },
  { q: "Cambios", a: "Nos reservamos el derecho de modificar estos términos en cualquier momento." },
];

export function Legal() {
  const [open, setOpen] = useState(0);
  return (
    <section id="legal" className="relative px-5 md:px-8 py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-end justify-between mb-14 gap-4">
          <div>
            <span className="tag mb-4 inline-flex">§ 007 · Legal</span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              className="font-display text-[8vw] md:text-[4.2vw] leading-[0.95] tracking-[-0.02em] font-light"
            >
              Legal <span className="italic font-serif text-[rgb(var(--brand))]">& privacidad</span>
            </motion.h2>
          </div>
        </div>

        <div className="border-t border-white/10">
          {items.map((it, i) => (
            <div key={it.q} className="border-b border-white/10">
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between py-5 md:py-6 text-left group"
                data-testid={`legal-${i}`}
              >
                <span className="flex items-baseline gap-4 md:gap-6">
                  <span className="font-mono text-xs text-[rgb(var(--paper-dim))]">0{i + 1}</span>
                  <span className="font-display text-xl md:text-2xl text-[rgb(var(--paper))] font-medium">{it.q}</span>
                </span>
                <span className={`font-mono text-xl transition-all text-[rgb(var(--paper-dim))] group-hover:text-[rgb(var(--brand))] ${open === i ? "rotate-45" : ""}`}>
                  +
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-7 pl-0 md:pl-12 max-w-3xl text-[rgb(var(--paper-dim))] leading-relaxed">{it.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
